// extracted by mini-css-extract-plugin
module.exports = {"errorsWrapper":"errorsWrapper__3UxW9","errorsList":"errorsList__33HVD","error":"error__2oihh"};